module.exports = __webpack_public_path__ + "static/media/chat.fe66b2ff.svg";